module.exports = __webpack_public_path__ + "img/right-guide.44e3f3e3.svg";